import { Link } from "react-router-dom";
import { MODULI } from "@/modulistica";
import { MobileNav } from "@/components/MobileNav";
import { SponsorStrip } from "@/components/SponsorStrip";

export default function Modulistica() {
  return (
    <div className="bg-[#e3edf6] text-[#0f172a] min-h-screen">
      <nav className="border-b border-[#e2e8f0] px-6 md:px-8 py-5 sticky top-0 bg-[#e3edf6]/90 backdrop-blur-md z-50">
        <div className="max-w-6xl mx-auto flex items-center justify-between">
          <Link to="/" data-testid="nav-logo" className="flex items-center gap-3">
            <img src="/logo-coppa.png" alt="Coppa dei Club" className="h-8 w-auto" />
            <span className="text-[#0284c7] font-mono-x text-xs">/ Hub</span>
          </Link>
          <div className="flex items-center gap-2 text-xs font-ui text-[#475569]">
            <a href="/#calendari" data-testid="nav-calendari" className="hidden sm:inline-block px-4 py-2 bg-white text-[#0f172a] hover:bg-[#38bdf8] transition-all rounded font-semibold border border-[#cbd5e1]">
              Calendari Gare
            </a>            <Link to="/circoli" data-testid="nav-circoli" className="hidden sm:inline-block px-4 py-2 bg-white text-[#0f172a] hover:bg-[#38bdf8] transition-all rounded font-semibold border border-[#cbd5e1]">
              Circoli
            </Link>
            <Link to="/galleria" data-testid="nav-galleria" className="hidden sm:inline-block px-4 py-2 bg-white text-[#0f172a] hover:bg-[#38bdf8] transition-all rounded font-semibold border border-[#cbd5e1]">
              Galleria foto
            </Link>

            <a href="/#regolamento" data-testid="nav-regolamento" className="hidden sm:inline-block px-4 py-2 bg-white text-[#0f172a] hover:bg-[#38bdf8] transition-all rounded font-semibold border border-[#cbd5e1]">
              Regolamento
            </a>
            <Link to="/modulistica" data-testid="nav-modulistica" className="hidden sm:inline-block px-4 py-2 bg-white text-[#0284c7] hover:bg-[#38bdf8] hover:text-[#0f172a] transition-all rounded font-semibold border border-[#38bdf8]">
              Modulistica
            </Link>
            <Link
              to="/admin"
              data-testid="nav-admin-login"
              className="hidden sm:inline-block px-4 py-2 bg-[#e2e8f0] text-[#0f172a] hover:bg-[#38bdf8] hover:text-[#0f172a] transition-all rounded font-semibold border border-[#cbd5e1]"
            >
              Login Admin
            </Link>
            <MobileNav active="modulistica" />
          </div>
        </div>
      </nav>

      <header className="py-16 md:py-20 px-6 md:px-8 border-b border-[#e2e8f0]">
        <div className="max-w-6xl mx-auto">
          <span className="font-mono-x text-xs text-[#0284c7] tracking-widest uppercase block mb-2">
            Coppa dei Club 2026-27
          </span>
          <h1 className="font-display text-4xl md:text-5xl text-[#0f172a] mb-4">Modulistica</h1>
          <p className="text-base text-[#475569] max-w-2xl leading-relaxed">
            Documenti e moduli ufficiali del campionato in formato PDF, pronti da scaricare e compilare.
          </p>
        </div>
      </header>

      <SponsorStrip />

      <main className="py-14 px-6 md:px-8">
        <div className="max-w-6xl mx-auto">
          {MODULI.length === 0 && (
            <div
              data-testid="modulistica-empty"
              className="bg-white border border-dashed border-[#cbd5e1] rounded-xl p-10 text-center"
            >
              <p className="text-sm text-[#475569] font-ui">
                La modulistica sarà disponibile a breve.
              </p>
            </div>
          )}
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4" data-testid="modulistica-grid">
            {MODULI.map((m, i) => (
              <div
                key={m.file}
                data-testid={`modulo-card-${i}`}
                className="bg-white border border-[#e2e8f0] rounded-xl p-6 flex flex-col gap-3 hover:border-[#cbd5e1] transition-colors"
              >
                <span className="w-10 h-10 rounded-lg bg-red-50 border border-red-100 flex items-center justify-center">
                  <svg className="w-5 h-5 text-[#dc2626]" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" aria-hidden="true">
                    <path d="M14 2H6a2 2 0 00-2 2v16a2 2 0 002 2h12a2 2 0 002-2V8z" strokeLinecap="round" strokeLinejoin="round" />
                    <path d="M14 2v6h6" strokeLinecap="round" strokeLinejoin="round" />
                  </svg>
                </span>
                <h3 className="font-bold text-[#0f172a] text-base leading-snug">{m.title}</h3>
                {m.desc && <p className="text-xs text-[#475569] font-ui leading-relaxed">{m.desc}</p>}
                <a
                  href={`/modulistica/${m.file}`}
                  download
                  data-testid={`modulo-download-${i}`}
                  className="mt-auto inline-flex items-center justify-center gap-2 px-4 py-2.5 bg-[#38bdf8] text-[#0f172a] font-bold text-xs uppercase tracking-wider rounded hover:bg-[#7dd3fc] transition-colors"
                >
                  <svg className="w-4 h-4" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" aria-hidden="true">
                    <path d="M12 3v12m0 0l-4-4m4 4l4-4M4 21h16" strokeLinecap="round" strokeLinejoin="round" />
                  </svg>
                  Scarica PDF
                </a>
              </div>
            ))}
          </div>
        </div>
      </main>

      <footer className="border-t border-[#e2e8f0] py-6 px-8 bg-[#d6e4f0] text-xs font-mono-x text-[#64748b] text-center">
        Coppa dei Club 2026-27 • Portale Ufficiale Calendari, Gironi Gold &amp; Silver • MSP Italia Umbria • Segreteria
        Generale:{" "}
        <a href="tel:3510262959" className="text-[#0284c7] hover:underline">
          3510262959
        </a>{" "}
        • Segreteria Coppa dei Club:{" "}
        <a href="mailto:coppadeiclubmspumbria@gmail.com" className="text-[#0284c7] hover:underline">
          coppadeiclubmspumbria@gmail.com
        </a>
      </footer>
    </div>
  );
}
